'use client'

export default function MaintenancePage() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-6">
      <div className="text-center max-w-xl mx-auto">
        <h1 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-6">
          Appointment of Managers to Visatec Legal
        </h1>
        <div className="text-left text-base md:text-lg text-gray-700 space-y-4">
          <p>
            Nick Curran and Bronwyn Lincoln of Thomson Geer have been appointed by the Victorian
            Legal Services Board as Managers of Visatec Legal Pty Ltd (in liquidation) trading as
            'Visatec'.
          </p>
          <p>
            The Managers have elected to wind up the affairs of Visatec. This means that Visatec is no
            longer operating as a law practice.
          </p>
          <p>
            We direct your attention to the following notice from the Victorian Legal Services Board
            regarding Mr Adewale Oladejo: <a href="https://lsbc.vic.gov.au/about-us/board-and-commissioner/record#StatementonAdewaleOladejoDojoPartnersPtyLtdandVisatecLegalPtyLtd" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">https://lsbc.vic.gov.au/about-us/board-and-commissioner/record#StatementonAdewaleOladejoDojoPartnersPtyLtdandVisatecLegalPtyLtd</a>
          </p>
          <p>
            This means that Mr Oladejo does not currently hold an Australian practising certificate and
            cannot continue to assist any future, current or past clients of Visatec as a lawyer.
          </p>
          <p>
            If you are a client or former client of Visatec and require further legal assistance, or if you are
            an interested party with queries regarding Visatec or Mr Oladejo, please contact the
            Managers at <a href="mailto:VisatecManager@tglaw.com.au" className="text-blue-600 hover:underline">VisatecManager@tglaw.com.au</a>.
          </p>
        </div>
      </div>
    </div>
  )
}